export default "__VITE_ASSET__44V8W1ux__"